import { render, staticRenderFns } from "./LiveApplyList.vue?vue&type=template&id=37cd5640&scoped=true&"
import script from "./LiveApplyList.vue?vue&type=script&lang=js&"
export * from "./LiveApplyList.vue?vue&type=script&lang=js&"
import style0 from "./LiveApplyList.vue?vue&type=style&index=0&id=37cd5640&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cd5640",
  null
  
)

export default component.exports